import api from './index'

export function getPublicHolidays(params) {
  return api.get('/api/v1/business-calendar/public-holidays', { params })
}

export function createPublicHoliday(data) {
  return api.post('/api/v1/business-calendar/public-holidays', data)
}

export function updatePublicHoliday(publicHolidayCode, data) {
  return api.put(`/api/v1/business-calendar/public-holidays/${publicHolidayCode}`, data)
}

export function deletePublicHoliday(publicHolidayCode) {
  return api.delete(`/api/v1/business-calendar/public-holidays/${publicHolidayCode}`)
}

export function getBranchCalendar(branchCode, params) {
  return api.get(`/api/v1/business-calendar/branches/${branchCode}`, { params })
}

export function updateWeeklyRules(branchCode, year, data) {
  return api.put(`/api/v1/business-calendar/branches/${branchCode}/weekly-rules`, data, { params: { year } })
}

export function createDateOverride(branchCode, data) {
  return api.post(`/api/v1/business-calendar/branches/${branchCode}/date-overrides`, data)
}

export function updateDateOverride(branchCode, dateOverrideCode, data) {
  return api.put(`/api/v1/business-calendar/branches/${branchCode}/date-overrides/${dateOverrideCode}`, data)
}

export function deleteDateOverride(branchCode, dateOverrideCode) {
  return api.delete(`/api/v1/business-calendar/branches/${branchCode}/date-overrides/${dateOverrideCode}`)
}

export function updatePickupPolicy(data) {
  return api.put('/api/v1/business-calendar/pickup-policy', data)
}

export function copyBusinessCalendar(data) {
  return api.post('/api/v1/business-calendar/copy', data)
}
